export const GOOGLE_AD_CLIENT_ID = '2787961';

// To build a ad unit, we need to know the ad locale
// These locale names are set by the ad server
export const googleLocaleMapping = {
	'en-US': 'COM',
	'fr-BE': 'BEF',
};

export type GoogleAdLocale = keyof typeof googleLocaleMapping;
